import { DataTableInterface } from "../types/interface";

const turbo2 : DataTableInterface[] = [
    { number: "2", bonus: "0", premiers: "3,000,000", derniers: "1,800,000" },
    { number: "1", bonus: "1", premiers: "48,000", derniers: "32,000" },
    { number: "0", bonus: "2", premiers: "48,000", derniers: "32,000" },
];

const turbo3 : DataTableInterface[] = [
    { number: "2", bonus: "0", premiers: "1,000,000", derniers: "600,000" },
    { number: "1", bonus: "1", premiers: "36,000", derniers: "24,000" },
    { number: "0", bonus: "2", premiers: "36,000", derniers: "24,000" },
];

const turbo4 : DataTableInterface[] = [
    { number: "2", bonus: "0", premiers: "500,000", derniers: "300,000" },
    { number: "1", bonus: "1", premiers: "30,000", derniers: "20,000" },
    { number: "0", bonus: "2", premiers: "30,000", derniers: "20,000" },
];

const turbo5 : DataTableInterface[] = [
    { number: "2", bonus: "0", premiers: "300,000", derniers: "200,000" },
    { number: "1", bonus: "1", premiers: "15,000", derniers: "9,000" },
    { number: "0", bonus: "2", premiers: "15,000", derniers: "9,000" },
];

export const lottoTurboData = [
    {
        game: "TURBO 2",
        data: [...turbo2]
    },
    {
        game: "TURBO 3",
        data: [...turbo3]
    },
    {
        game: "TURBO 4",
        data: [...turbo4]
    },
    {
        game: "TURBO 5",
        data: [...turbo5]
    }
]